<template>
	<div class="element-text is-empty" :class="classes('input')"><div v-html="macro(content)"></div></div>
</template>

<script>
	import store from '../../store'
	export default {
		props: {
            definition: { type: Object, required: true },
            element:    { type: Object, required: true },
        },
		computed: {
			content() { return this.definition.options && this.definition.options.content ? this.definition.options.content : '' }
		},
		methods: {
            classes(index) { return store.getters['classes'](index) },
			macro  (value) { return store.getters['macro'](value) },
		}
	}
</script>
